import { ref, computed } from 'vue'
import { useRouter } from '#app'
import { useEventBus } from '@vueuse/core'
const isOpenEditorModal = ref(false)
const closeEditorModal = () => {
  isOpenEditorModal.value = false
}

const editorForms = ref([])
const activeFormId = ref(0)
const activeFormUuid = ref(null)

const setActiveFormId = (id) => {
  activeFormId.value = id
}

const currentForm = computed(() =>
  editorForms.value.find((e) => e.id === activeFormId.value)
)
const openEditorModal = () => {
  isOpenEditorModal.value = true
  const editorSavedBus = useEventBus('editor-form-opened')
  editorSavedBus.emit({ data: currentForm.value.uuid })
}

const setCanState = (bool) => {
  const elem = currentForm.value
  elem.canSave = bool
}

function randomString(length = 5) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

const addEditorForm = (form, autoActivate, custom) => {
  if (custom === 'admin-warehouseman') {
    activeFormUuid.value = form?.uuid
    navigateTo('/warehousesman/editor-user')
    return
  }

  form.custom = custom

  const current = editorForms.value.find(
    (e) => e.uuid === form.uuid && e.name === form.name
  )
  if (current) {
    setActiveFormId(current.id)
  } else {
    form.id = randomString()
    editorForms.value.push(form)

    if (autoActivate) {
      activeFormId.value = form.id
    }
  }

  openEditorModal()
}

const closeById = (tab) => {
  const targetIndex = editorForms.value.findIndex(
    (e) => e.uuid === tab.uuid && e.name === tab.name
  )
  if (targetIndex === -1) return
  editorForms.value.splice(targetIndex, 1)
}

const closeTab = () => {
  const targetIndex = editorForms.value.indexOf(currentForm.value)
  editorForms.value.splice(targetIndex, 1)
  const next = targetIndex + 1
  activeFormId.value =
    editorForms.value[next < editorForms.value.length ? next : 0]?.id

  if (!editorForms.value.length) {
    closeEditorModal()
  }
}

export {
  isOpenEditorModal,
  closeEditorModal,
  openEditorModal,
  editorForms,
  addEditorForm,
  activeFormId,
  activeFormUuid,
  setActiveFormId,
  closeTab,
  currentForm,
  setCanState,
  closeById,
}
